var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademicFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6707 19.3913L21.8669 18.1944L23.0638 19.3913C23.3005 19.628 23.4618 19.9295 23.5271 20.2578C23.5925 20.5861 23.559 20.9265 23.4309 21.2357C23.3028 21.545 23.0859 21.8094 22.8076 21.9954C22.5292 22.1813 22.202 22.2806 21.8673 22.2806C21.5325 22.2806 21.2053 22.1813 20.9269 21.9954C20.6486 21.8094 20.4317 21.545 20.3036 21.2357C20.1755 20.9265 20.142 20.5861 20.2074 20.2578C20.2727 19.9295 20.434 19.628 20.6707 19.3913ZM13.6641 7.44141L21.3233 15.1C21.4502 15.2269 21.5215 15.3991 21.5215 15.5786C21.5215 15.7581 21.4502 15.9303 21.3233 16.0572L15.5792 21.802C15.4523 21.9289 15.2801 22.0002 15.1006 22.0002C14.9211 22.0002 14.7489 21.9289 14.622 21.802L8.8779 16.0572C8.75098 15.9303 8.67969 15.7581 8.67969 15.5786C8.67969 15.3991 8.75098 15.2269 8.8779 15.1L14.1434 9.8345L12.7068 8.39864L13.6654 7.44141H13.6641ZM15.1006 10.7924L10.3137 15.5786H19.8868L15.1006 10.7924Z",
    fill: "#F34970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicFilterIcon);
export default __webpack_public_path__ + "static/media/AcademicFilterIcon.8e4f2f00d7562ed65b90a8d1814508a9.svg";
export { ForwardRef as ReactComponent };